import { useLanguage } from "@tlc/ls2pac/components/Language";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import React from "react";

export interface SerialIssueInformationProps {
  hold: HostSystemItemView;
}
export const SerialIssueInformation: React.FC<SerialIssueInformationProps> = ({
  hold,
}) => {
  const { chronology, enumeration } = hold;
  const { translate } = useLanguage();
  return (
    <>
      {chronology && chronology.length > 0 && (
        <div className="chronology">
          <span>{translate("chronology")}:</span> <strong>{chronology}</strong>
        </div>
      )}
      {enumeration && enumeration.length > 0 && (
        <div className="enumeration">
          <span>{translate("numbering")}:</span> <strong>{enumeration}</strong>
        </div>
      )}
    </>
  );
};
